interface SubmitButtonProps {
    buttonText: string
}

export default function SubmitButton(props: SubmitButtonProps) {
    const { buttonText } = props; 

    return (
        <button 
            type="submit" 
            className="w-full py-2 text-white bg-[#93885B] rounded-xl shadow"
        >
            {buttonText}
        </button>
    )
}